import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { TemplatesRoutingModule } from './templates-routing.module';
import { TemplateSelectionComponent } from './components/template-selection/template-selection.component';
import { TemplateFormComponent } from './components/template-form/template-form.component';
import { ShareInterviewLinkComponent } from './components/share-interview-link/share-interview-link.component';
import { MatIcon } from "@angular/material/icon";
import { MatTooltipModule } from '@angular/material/tooltip';
import { SpinnerModule } from "../../shared/components/spinner/spinner.module";



@NgModule({
  declarations: [
    TemplateSelectionComponent,
    TemplateFormComponent,
    ShareInterviewLinkComponent
  ],
  imports: [
    CommonModule,
    TemplatesRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    MatIcon,
    MatTooltipModule,
    SpinnerModule
],
  exports: [
    TemplateSelectionComponent     // <-- ADD THIS
  ]
})
export class TemplatesModule { }
